"use client";

import LocationCard from "../venue-listing/locationCard/LocationCard";
import { Link } from "@/components/CustomLink";
import { Skeleton } from "@/components/ui/skeleton";
import capitalizeWords from "@/lib/caplitalize-words";
import { useTranslation } from "@/hooks/translationContext";

interface Item {
  id: number;
  title: string;
  href: string;
}

interface Props {
  items: Item[];
  title?: string;
}

export function SiteMapList(props: Props) {
  const { t } = useTranslation();
  return (
    <div className="relative gap-2">
      <div className="flex gap-2 p-2">
        <h2 className="text-primary font-bold text-sm">{props.title || t("footer-pages-title")}</h2>
      </div>

      <div className="absolute left-0 w-full h-[1px] bg-gray-secondary md:flex hidden" />

      <div className="grid grid-cols-1 md:grid-cols-2 w-full items-start gap-2 md:gap-4 py-4 md:py-6">
        {props.items.map((location, index) => {
          return (
            <Link
              title={location.title}
              key={index}
              href={location.href}
              className="w-full"
            >
              <LocationCard title={capitalizeWords(location.title)} />
            </Link>
          );
        })}
      </div>

      <div className="absolute left-0 w-full h-[1px] bg-gray-secondary md:flex hidden" />
    </div>
  );
}

export function SiteMapCardLoading() {
  return (
    <div className="flex flex-col gap-2">
      <div className="p-2">
        <Skeleton className="custom-animate-pulse w-40 h-3" />
      </div>

      <div className="py-6 flex flex-wrap gap-x-4 gap-y-3">
        {Array.from(Array(16).keys()).map((item, key: number) => (
          <Skeleton
            key={key}
            className="custom-animate-pulse max-md:w-full w-72 px-4 py-3 rounded-2xl h-[42px]"
          />
        ))}
      </div>
    </div>
  );
}
